export default __webpack_public_path__ + "static/room-2b19a20d2a6c4b26fe4f622ac74c639e.webp";